import { styled } from "@mui/material";

import { DefaultIconButton } from "./defaultIconButton";

const BACKGROUND_COLOR = "#C6ECC9";
const COLOR = "#194D1E";
const HOVER_BACKGROUND_COLOR = "#8CD993";
const HOVER_COLOR = "#133916";

export const ConfirmIconButton = styled(DefaultIconButton)`
    background: ${BACKGROUND_COLOR};
    color: ${COLOR};
    &:hover {
        background: ${HOVER_BACKGROUND_COLOR};
        color: ${HOVER_COLOR};
    }
`;
